import React, { useEffect, useState, useMemo } from 'react';
import {
  Modal, Button, Card, Descriptions, Timeline, Image, Typography,
  List, Space, Input, Select, Row, Col, message, Dropdown, Tag, Checkbox, Form, Radio, Drawer, Table, Divider, Tooltip
} from 'antd';
import {
  ArrowLeftOutlined, PlusOutlined, DeleteOutlined, MoreOutlined, UndoOutlined, CheckOutlined,
  CloseOutlined
} from '@ant-design/icons';
import { getConversationInfo, getUserInfo, getConversation, getOptimusBrand, addOptimusInspection, getConversationAiReview, getPartner, getSocialMediaPlatforms,getPartnerBrands } from "../services/conversationService.js";
import { getExamine, getExamineLog, examineConversation, createTicket, checkPartnerTicketLimit, getTicketLog,getWorkOrderId } from "../services/ctaService.js"
import moment from "moment";
import { useNavigate, useLocation } from 'react-router-dom';
import Jump from '../assets/mti-跳转.svg';
import countryJson from '../utils/jsonData/countries.json';
import industry from '../utils/jsonData/industry.json';
import logIcon from '../assets/log.svg';
import { useGlobalState } from '../hooks/useGlobalState.js'
import CtaInfoSection from './common/CtaInfoSection.jsx';
import CtaBrandRow from './common/CtaBrandRow.jsx';
import CollapsibleTextBlock from './common/CollapsibleTextBlock.jsx';
const { Text, Paragraph } = Typography;
const ConversationDetail = () => {
  const { userProfile } = useGlobalState();
  const navigate = useNavigate();
  const location = useLocation();
  const [conversation, setConversation] = useState(location.state?.conversation);
  const [loading, setLoading] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [messages, setMessages] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [aiReviewData, setAiReviewData] = useState([]);
  const [examine, setExamine] = useState({
    ctas: [],
    ctasNew: [],
    ctaSource: '',
    ctaSourceNew: '',
    relatedBrands: '',
    relatedBrandsNew: '',
    riskLevel: '',
    riskLevelNew: '',
    userId: '',
    conversationId: '',
    ctasId: [],
    ctasNames: []
  });
  const [examineLogList, setExamineLogList] = useState([]);
  const [ctas, setCtas] = useState([]);
  const [isLogCenterOpen, setIsLogCenterOpen] = useState(false);
  const [source, setSource] = useState('')
  const [involvedOrganization, setInvolvedOrganization] = useState('')
  const [riskLevel, setRiskLevel] = useState('')
  const [riskCore, setRiskCore] = useState('')
  const [boxCount, setBoxCount] = useState(0);
  const [ctaSyncData, setCtaSyncData] = useState([]);
  const [syncCtaModal, setSyncCtaModal] = useState(false);

  const [syncTicketModal, setSyncTicketModal] = useState(false);
  const [ticketDetails, setTicketDetails] = useState({});
  const [newBrand, setNewBrand] = useState(false);
  const [partnerInfo, setPartnerInfo] = useState({});
  const [partnerInfoLoaded, setPartnerInfoLoaded] = useState(false);
  const [socialPlatform, setSocialPlatform] = useState([]);
  const [brands, setBrands] = useState([]);
  const [partnerBrands, setPartnerBrands] = useState([]);
  const [countryCode, setCountryCode] = useState([]);
  const previousRoute = location.state?.from;
  const [form] = Form.useForm();
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [initialized, setInitialized] = useState(false);
  const [originalValues, setOriginalValues] = useState({
    source: '',
    involvedOrganization: '',
    riskLevel: '',
    ctas: []
  });
  const [workOrderMap, setWorkOrderMap] = useState({});

  const isCompanyUser = userProfile?.user?.userStatus === "Company User";

  const brandRows = useMemo(() => {
    return ctas
      .filter(cta =>
        ctaSyncData.some(item => item.ctaId === cta.ctaId) &&
        cta.ctaType === "URL"
      )
      .map(cta => ({
        cta: cta.finalCta || cta.cta,
        ctaId: cta.ctaId,
      }));
  }, [ctas, ctaSyncData]);

  const ctaInfoSections = useMemo(() => {
    return ctas
      .filter(cta =>
        ctaSyncData.some(item => item.ctaId === cta.ctaId) &&
        cta.ctaType === "Phone"
      )
      .map(cta => ({
        cta: cta.finalCta || cta.cta,
        ctaId: cta.ctaId,
      }));
  }, [ctas, ctaSyncData]);

  const platformOptions = useMemo(() => {
    const sorted = [...(socialPlatform || [])].sort((a, b) => {
      if (a.type === 'CHINESE' && b.type === 'FOREIGN') return -1;
      if (a.type === 'FOREIGN' && b.type === 'CHINESE') return 1;
      return 0;
    });
    return sorted.map(p => ({
      value: p.platformId,
      label: p.chineseName || p.englishName || p.platformId
    }));
  }, [socialPlatform]);

  const partnerBrandOptions = useMemo(() => {
    const raw = Array.isArray(partnerBrands) ? partnerBrands : [];
    if (raw.length === 0) return [];
    const item = raw[0];
    if (typeof item === 'string') {
      return raw.map(b => ({ value: b, label: b }));
    }
    if (item?.value !== undefined && item?.label !== undefined) {
      return raw;
    }
    return raw.map(b => {
      const value = b.brandId;
      const label = b.chineseName ?? b.englishName ?? String(value);
      return { value, label };
    });
  }, [partnerBrands]);

  const getBrandLabelByValue = (brandValue) => {
    const matchedBrand = partnerBrandOptions.find(option => String(option.value) === String(brandValue));
    return matchedBrand?.label ?? String(brandValue ?? '');
  };

  const hasTicketCreated = (workOrder) =>
    Boolean(workOrder && (workOrder.workOrderId || workOrder.brandName));

  const ticketDisabledTooltip = 'This CTA already has a ticket and cannot be used to create another ticket.';

  useEffect(() => {
    const fetchWorkOrders = async () => {
      const companyId = userProfile?.user?.companyId;
      if (!ctas.length || !companyId) return;

      const ctasToFetch = ctas.filter(cta => cta.ctaType === 'URL' || cta.ctaType === 'Phone');
      if (!ctasToFetch.length) return;

      const results = {};
      await Promise.all(
        ctasToFetch.map(async (cta) => {
          try {
            const res = await getWorkOrderId(cta.ctaId, companyId,userProfile?.user?.userId);
            const data = res?.result ?? res?.data ?? res;
            if (data?.workOrderId || data?.brandName) {
              results[cta.ctaId] = {
                workOrderId: data.workOrderId ?? data.id ?? '',
                brandName: data.brandName ?? data.brand ?? ''
              };
            }
          } catch {
            // No work order or API error, skip
          }
        })
      );
      setWorkOrderMap(results);
    };
    fetchWorkOrders();
  }, [ctas, userProfile?.user?.companyId]);

  useEffect(() => {
    if (userProfile?.user?.userStatus !== "Company User") return;

    const hasPhoneType = ctas.some(cta => cta.ctaType === "Phone");
    if (!hasPhoneType) return;

    const getSocialMediaPlatformsList = async () => {
      try {
        const response = await getSocialMediaPlatforms();
        setSocialPlatform(response?.result?.data ?? []);
      } catch (error) {
        console.error('Fail to fetch social media platforms:', error);
      }
    };
    getSocialMediaPlatformsList();
  }, [ctas, userProfile?.user?.userStatus]);
  useEffect(() => {
    const fetchPartnerInfo = async () => {
      if (!userProfile?.user?.companyId) {
        setPartnerInfoLoaded(true);
        return;
      }
      try {
        const res = await getPartner(userProfile.user.companyId);
        setPartnerInfo(res.result ?? {});
        getPartnerBrandsList(res.result?.partnerId);
      } catch (error) {
        console.error('获取合作方信息失败：', error);
        setPartnerInfo({});
      } finally {
        setPartnerInfoLoaded(true);
      }
    };

    fetchPartnerInfo();
  }, [userProfile?.user?.companyId]);

  const columns = [
    {
      title: 'RuleName',
      dataIndex: 'ruleName',
      key: 'ruleName',
      width: 20,
      render: (text, record) => {
        return <Text >{text}</Text>;
      },
    },
    {
      title: 'AI Review',
      dataIndex: 'aiReview',
      key: 'aiReview',
      width: 20,
      render: (text, record) => {
        if (text === null || text === undefined) {
          return null;
        }
        return (
          <Text >
            {text === 'CORRECT' ? (
              <CheckOutlined style={{ color: 'green' }} />
            ) : (
              <CloseOutlined style={{ color: 'red' }} />
            )}
          </Text>
        );
      },
    },
    {
      title: 'Foundation',
      dataIndex: 'foundation',
      key: 'foundation',
      width: 700,
      render: (text) => (
        <span style={{ whiteSpace: 'pre-line' }}>
          {text}
        </span>
      ),
    }
  ]

  useEffect(() => {
    const options = Object.entries(countryJson).map(([key, value]) => ({
      value: key,
      label: `${value.emoji} ${value.englishName}`,
    }));
    setCountryCode(options);
    getOptimusBrands(false);

  }, [])


  const getPartnerBrandsList = async (partnerId) => {
    const res = await getPartnerBrands(partnerId);
    setPartnerBrands(res ?? []);
  }

  useEffect(() => {
    const initData = async () => {
      try {
        if (!conversation) {
          await fetchConversationInfo();
        }
        if (conversation) {
          await fetchUserInfoAndMessages();
          await fetchExamine();
          if (!isCompanyUser) {
            const res = await getConversationAiReview(conversation.conversationId);
            if (res?.data?.result === 'MANUAL') {
              return;
            }
            const tableData = Object.keys(res.data)
              .filter(key => key !== 'result' && key !== 'backup')
              .map((key, index) => {
                const raw = res.data[key];
                let status = null;
                let reason = null;

                if (raw) {
                  // 查找第一个连字符的位置
                  const dashIndex = raw.indexOf('-');
                  if (dashIndex !== -1) {
                    status = raw.substring(0, dashIndex).trim();
                    reason = raw.substring(dashIndex + 1).trim();
                  }
                }

                return {
                  key: index,
                  ruleName: key,
                  aiReview: status,
                  foundation: reason || '',
                };
              });

            setAiReviewData(tableData);
          }

        }
      } catch (error) {
        console.error("Initialization failed:", error);
      }
    };
    initData();
  }, [conversation]);

  const getOptimusBrands = async (isRefresh) => {

    const optimusbrands = await getOptimusBrand(isRefresh);
    const brandList = Object.entries(optimusbrands).map(([key, value]) => ({
      value: value.brandId,
      label: `${value.englishName} [${value.chineseName}]`,
    }));
    setBrands(brandList);
  }


  const fetchConversationInfo = async () => {
    const urlParams = location.pathname
    const conversationRef = urlParams.split("/")[2]
    const fetchedConversation = await getConversation(conversationRef)
    setConversation(fetchedConversation)
  }

  const handleDownload = async (url, filename) => {
    try {
      const res = await fetch(url);
      const blob = await res.blob();
      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename || 'download.eml';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Download failed:', error);
    }
  };

  const fetchLog = async () => {
    setIsLogCenterOpen(true);
    try {
      let res = null;
      if (!isCompanyUser) {
        res = await getExamineLog(conversation.conversationId);
        if (res.data != null) {
          setExamineLogList(res.data);
        }
      } else {
        res = await getTicketLog(conversation.conversationId, userProfile?.user?.companyId);
        if (res != null) {
          setExamineLogList(res);
        }
      }
    } catch (error) {
      console.error('Fetch log error:', error);
    }
    setLoading(false);
  }

  const formatLogObject = (record) => {
    const isAddToOptimus = record?.content?.includes('Add to Optimus');
    if (!isAddToOptimus) {
      return record?.conversationId || "-";
    }

    const objectMatch = record?.content?.match(/object:(.*?)(?=\s+modifier:|Result:|$)/);
    if (objectMatch?.[1]) {
      return objectMatch[1].trim() || "-";
    }

    return record?.conversationId || "-";
  };

  const formatLogOperation = (record) => {
    if (!record?.content) {
      return "-";
    }

    return record.content
      .replace(/object:.*?(?=\s+modifier:|Result:|$)/, '')
      .replace(/\s{2,}/g, ' ')
      .trim() || "-";
  };

  const logColumns = [
    {
      title: "Object",
      dataIndex: "conversationId",
      key: "conversationId",
      width: 200,
      render: (_, record) => formatLogObject(record)
    },
    {
      title: "Operation",
      dataIndex: "content",
      key: "content",
      width: 200,
      render: (_, record) => formatLogOperation(record)
    },
    {
      title: "Operator",
      dataIndex: "createdBy",
      key: "createdBy",
      width: 200,
      render: (_, record) => record.createdBy || "-"
    },
    {
      title: "Operation Time",
      dataIndex: "createTime",
      key: "createTime",
      width: 200,
      render: (_, record) => {
        const operTimeStr = record.createTime;
        if (!operTimeStr) return "-";
        const utcString = operTimeStr.replace(" ", "T") + "Z";
        const date = new Date(utcString);
        return date.toLocaleString();
      }
    },
    {
      title: "Result",
      dataIndex: "result",
      key: "result",
      width: 200,
      render: (_, record) => {
        const result = record.result || "Success";
        const color = result === "Success" ? "green" :
          result === "Fail" ? "red" : "inherit";
        return <span style={{ color }}>{result}</span>;
      }
    },
  ];

  const logTicketColumns = [
    {
      title: "Object",
      dataIndex: "operParam",
      key: "operParam",
      width: 200,
      render: (_, record) => (
        <div style={{ whiteSpace: "pre-wrap" }}>
          {record.operParam || "-"}
        </div>
      )
    },
    {
      title: "Operation",
      dataIndex: "operParam",
      key: "operParam",
      width: 200,
      render: (_, record) => (
        <div style={{ whiteSpace: "pre-wrap" }}>
          {"Create Ticket"}
        </div>
      )
    },
    {
      title: "Operator",
      dataIndex: "operName",
      key: "operName",
      width: 200,
      render: (_, record) => record.operName || "-"
    },
    {
      title: "Operation Time",
      dataIndex: "operTime",
      key: "operTime",
      width: 200,
      render: (_, record) => {
        const operTimeStr = record.operTime;
        if (!operTimeStr) return "-";
        const utcString = operTimeStr.replace(" ", "T") + "Z";
        const date = new Date(utcString);
        return date.toLocaleString();
      }
    },
    {
      title: "Result",
      dataIndex: "result",
      key: "result",
      width: 200,
      render: (_, record) => {
        const result = record.result || "Success";
        const color = result === "Success" ? "green" :
          result === "Fail" ? "red" : "inherit";
        return <span style={{ color }}>{result}</span>;
      }
    },
  ];

  const fetchUserInfoAndMessages = async () => {
    setLoading(true);
    const userInfo = await getUserInfo(conversation.userId);
    setUserInfo(userInfo);
    const messages = await getConversationInfo(conversation.userId, conversation.externalRef);
    setMessages(messages.map(msg => {
      let content, sender, tpContent;
      if (msg.role === 'user') { // user message
        sender = 'User';
        content = msg.content?.content;
        if ((msg.content?.type === 'image' || msg.content?.type === 'eml') && msg.content?.content?.imageUrls?.length > 0) {
          if (msg.content?.type === 'image') {
            content = <>
              {msg.content.content.text}<br />
              {msg.content.content.imageUrls.map((url, index) => (
                <Image key={index} width={200} src={url} />
              ))}
            </>;
          } else {
            content = <>
              {msg.content.content.text}<br />
              fileName:{msg.content.fileName}<br />
              <Button type="link" onClick={() => handleDownload(msg.content.content.imageUrls[0], msg.content.fileName)}>Download EML attachments</Button>
            </>;
          }

        }
      } else { // AI message
        sender = 'AI';
        content = msg.fullContent ? msg.fullContent.content : msg.content.content;
        tpContent = msg.tpContent?.trim();
      }
      const isQuestionBankValue = msg.isQuestionBank === 1 || msg.isQuestionBank === true;
      return {
        time: msg.createdAt,
        sender: sender,
        content: content,
        tpContent: tpContent,
        isQuestionBank: isQuestionBankValue
      }
    }
    ));
    setLoading(false);
  }

  const fetchExamine = async () => {
    setLoading(true);
    const examine = await getExamine(conversation.externalRef, conversation.conversationId);
    setCtas(examine.ctas.map(item => ({ ...item, key: item.ctaId })))
    setSource(examine.ctaSource)
    setInvolvedOrganization(examine.relatedBrands)
    setRiskLevel(examine.riskLevel)
    setRiskCore(examine.riskcore)
    setExamine(examine)
    setLoading(false);
    setOriginalValues({
      source: examine.ctaSource,
      involvedOrganization: examine.relatedBrands,
      riskLevel: examine.riskLevel,
      ctas: examine.ctas.map(cta => cta.cta),
      auditStatus: examine.auditStatus
    });
    setIsButtonDisabled(examine.auditStatus == 0 ? false : true);
    setInitialized(true);
  }

  const handleNavigate = () => {
    if (previousRoute == undefined) {
      navigate('/conversations');
    } else {
      const targetPath = previousRoute.pathname;

      if (targetPath === '/cta') {
        navigate('/cta', {
          state: {
            pageInfo: previousRoute.pageInfo,
            filters: previousRoute.filters,
            sorter: previousRoute.sorter,
            currentRecord: previousRoute.ctaData,
            needReopenDrawer: true
          }
        });
      } else if (targetPath === '/conversations') {
        navigate('/conversations', {
          state: {
            pageInfo: previousRoute.pageInfo,
            filters: previousRoute.filters
          }
        });
      } else {
        navigate(targetPath);
      }
    }
  };

  const handleEdit = (key, field, value) => {
    setCtas(prevCtas =>
      prevCtas.map(cta =>
        cta.key === key ? { ...cta, [field]: value } : cta
      )
    );
    const itemIndex = examine.ctasNew.findIndex(item => item.key === key);
    let newExamine;
    if (itemIndex === -1) { // 如果没有找到，进行新增
      newExamine = [...examine.ctasNew, { key, [field]: value, ctaId: key }];
    } else { // 如果找到了，进行修改
      newExamine = examine.ctasNew.map(item =>
        item.key === key ? { ...item, [field]: value } : item
      );
    }
    const updatedExamine = {
      ...examine, ctasNew: newExamine
    }
    setExamine(updatedExamine);
  };

  const handleEditSource = (value) => {
    setSource(value)
    const newExamine = {
      ...examine,
      ctaSourceNew: value,
    }
    setExamine(newExamine);
  }

  useEffect(() => {
    if (!initialized) return;
    if (!originalValues.ctas) return;

    const isSourceChanged = source !== originalValues.source;
    const isOrgChanged = involvedOrganization !== originalValues.involvedOrganization;
    const isRiskChanged = riskLevel !== originalValues.riskLevel;

    // 检查 CTA 是否修改过（数量不同或有内容不同）
    const isCtaChanged = (
      ctas.length !== originalValues.ctas.length ||
      ctas.some(cta => !originalValues.ctas.includes(cta.cta))
    );

    const anyChanged = isSourceChanged || isOrgChanged || isRiskChanged || isCtaChanged;

    if (anyChanged) {
      // 有变化 → 可点击
      setIsButtonDisabled(false);
    } else {
      // 全部恢复原状 → 恢复到 auditStatus 控制的初始状态
      setIsButtonDisabled(originalValues.auditStatus == 0 ? false : true);
    }
  }, [source, involvedOrganization, riskLevel, ctas, originalValues, initialized]);

  const handleEditInvolvedOrganization = (value) => {
    setInvolvedOrganization(value)
    const newExamine = {
      ...examine, relatedBrandsNew: value
    }
    setExamine(newExamine);
  }

  const deleteCta = (key) => {
    const updated = ctas.filter(cta => cta.key !== key);
    setCtas(updated);
    const isFlag = isKeyFromDateNow(key)
    if (!isFlag) {
      const ctasId = examine.ctas
        .filter(cta => cta.ctaId === key)
        .map(cta => cta.ctaId);
      const ctasNames = examine.ctas
        .filter(cta => cta.ctaId === key)
        .map(cta => cta.cta);
      setExamine(prev => ({
        ...prev,
        ctas: prev.ctas.filter(cta => cta.ctaId !== key),
        ctasNew: prev.ctasNew.filter(cta => cta.ctaId !== key),
        ctasId: [...prev.ctasId, ...ctasId],
        ctasNames: [...prev.ctasNames, ...ctasNames]
      }));
    } else {
      setExamine(prev => ({
        ...prev,
        ctas: prev.ctas.filter(cta => cta.ctaId !== key),
        ctasNew: prev.ctasNew.filter(cta => cta.ctaId !== key)
      }));
    }
  };

  const isKeyFromDateNow = (key) => {
    // 检查是否为数字
    if (typeof key !== 'number') return false;

    // 检查是否在合理的时间戳范围内（2020-2030年）
    const minTimestamp = 1577836800000;
    const maxTimestamp = 1893456000000;
    return key >= minTimestamp && key <= maxTimestamp;
  };
  const addCta = () => {
    setCtas([
      ...ctas,
      {
        key: Date.now(),
        value: '',
        idCta: '-',
        ctaType: '-',
        isWhitelist: null,
        finalCta: '-',
        isMobile: '-',
      },
    ]);
  };

  const handleEditRiskLevel = (value) => {
    setRiskLevel(value)
    const newExamine = {
      ...examine,
      riskLevelNew: value,
    };
    if (value === "Minimal") {
      setRiskCore(150)
    } else if (value === "Low") {
      setRiskCore(350)
    } else if (value === "Moderate") {
      setRiskCore(550)
    } else if (value === "High") {
      setRiskCore(850)
    }
    setExamine(newExamine);
  }

  const handleJumpToCTADetail = (cta) => {
    if (cta.cta || cta.finalCta) {
      const params = new URLSearchParams({
        searchCta: cta.cta || cta.finalCta,
        autoSearch: 'true'
      });
      window.open(`/cta?${params.toString()}`, '_blank');
    } else {
      message.warning('CTA信息不完整无法跳转');
    }
  };

  const handleExamineConversation = async (addToQuestionBank = false) => {
    if (loading) return;
    setLoading(true);
    try {
      const updatedExamine = {
        ...examine,
        userId: userProfile?.user?.userId,
        conversationId: conversation.conversationId,
        addToQuestionBank: addToQuestionBank,
        ctasNew: examine.ctasNew.map(cta => {
          const { key, ...ctaWithoutKey } = cta;
          return ctaWithoutKey;
        })
      };

      const res = await examineConversation(updatedExamine);

      setCtas(res.ctas.map(item => ({ ...item, key: item.ctaId })));
      setSource(res.ctaSource);
      setInvolvedOrganization(res.relatedBrands);
      setRiskLevel(res.riskLevel);
      setExamine(res);
      if (addToQuestionBank) {
        setMessages(prevMessages =>
          prevMessages.map(msg => ({ ...msg, isQuestionBank: true }))
        );
      }
      message.success('Audit succeed');
      await fetchUserInfoAndMessages();
      setIsButtonDisabled(true);
    } catch (error) {
      message.error('Audit failed');
      console.error('Audit error:', error);
    } finally {
      setLoading(false);
    }
  };

  // 用于将 "**加粗**文本" 转换为 JSX 结构的工具函数
  const renderWithBold = (text) => {
    const parts = text.split(/(\*\*.*?\*\*)/);
    return parts.map((part, index) => {
      const match = part.match(/^\*\*(.*?)\*\*$/);
      if (match) {
        return (
          <span
            key={index}
            style={{
              color: '#000000',
            }}
          >
            {match[1]}
          </span>
        );
      } else {
        return <span key={index}>{part}</span>;
      }
    });
  };

  const renderParagraphs = (text) => {
    return text
      .split('\n')
      .map(line => line.trim())
      .filter(line => line.length > 0)
      .map((line, index) => {
        const isBullet = line.startsWith('- ');
        const content = isBullet ? line.slice(2) : line;

        return (
          <div
            key={index}
            style={{
              marginBottom: 8,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {isBullet && (
              <span
                style={{
                  display: 'inline-block',
                  color: '#000',
                  fontSize: '12px',
                  marginRight: 8,
                  lineHeight: 1,
                }}
              >
                ●
              </span>
            )}
            <div style={{ flex: 1 }}>{renderWithBold(content)}</div>
          </div>
        );
      });
  };

  const JsonDisplay = ({ data, level = 0, parentKey = '' }) => {
    if (!data || typeof data !== "object") return <Text>{String(data) || "-"}</Text>;

    return (
      <List
        size="small"
        bordered={false}
        dataSource={Object.entries(data)}
        renderItem={([key, value]) => (
          <List.Item style={{ display: "flex", alignItems: "flex-start", paddingLeft: `${level * 12}px`, marginBottom: "8px" }}>
            <div style={{ minWidth: "200px", whiteSpace: "nowrap" }}>{key}:</div>
            <div style={{ flex: 1, wordBreak: "break-word" }}>
              {Array.isArray(value) ? (
                value.map((item, index) => (
                  <div key={index}>
                    {key === 'formatterCtasList' && index > 0 && <hr style={{ margin: '12px 0', borderTop: '1px solid #d9d9d9' }} />}
                    <JsonDisplay data={item} level={level + 1} parentKey={key} />
                  </div>
                ))
              ) : typeof value === "object" ? (
                <JsonDisplay data={value} level={level + 1} parentKey={key} />
              ) : key === 'advice' || key === 'explanation' ? (
                <>
                  {String(value)
                    .split('\n')
                    .map(line => line.trim())
                    .filter(line => line.length > 0)
                    .map((line, idx) => (
                      <Paragraph key={idx} style={{ marginBottom: '8px' }}>
                        {renderParagraphs(line)}
                      </Paragraph>
                    ))}
                </>
              ) : (key === 'cta' || key === 'finalCta') && parentKey === 'formatterCtasList' ? (
                <CollapsibleTextBlock text={String(value)} lines={3} />
              ) : (
                <Text>{String(value) || '-'}</Text>
              )}
            </div>
          </List.Item>
        )}
      />
    );
  };

  const menu = {
    items: [
      {
        key: '1',
        label: 'Approve and Add to Question Bank',
        onClick: () => handleExamineConversation(true)
      }
    ]
  };

  const onChangeCheckbox = (ctaId, finalCta, checked, ctaType) => {
    if (checked) {
      setCtaSyncData(prev => [...prev, { ctaId, finalCta, ctaType }]);
      setBoxCount(boxCount + 1);
    } else {
      setCtaSyncData(prev => prev.filter(item => item.ctaId !== ctaId));
      setBoxCount(boxCount - 1);
    }
  };

  const ctaAsyncOptimus = () => {
    setSyncCtaModal(true);
  };


  const handleSyncCtaClose = () => {
    form.resetFields();
    setSyncCtaModal(false);
    setNewBrand(false);
    setCtaSyncData([]);
    setBoxCount(0);
  }

  const ctaAsyncTicket = () => {
    if (ctaSyncData.length === 0) {
      message.warning('Please select at least one CTA.');
      return;
    }
    const initialDetails = {};
    ctaSyncData.forEach(item => {
      initialDetails[item.ctaId] = {
        brand: '',
        platform: '',
        type: item.ctaType,
        conversationId: conversation.conversationId,
        email: userProfile.username,
        cta: item.finalCta,
        ctaId: item.ctaId,
      };
    });
    setTicketDetails(initialDetails);
    setSyncTicketModal(true);
  }

  const handleTicketChange = (ctaId, field, value) => {
    setTicketDetails(prev => ({
      ...prev,
      [ctaId]: {
        ...prev[ctaId] || { brand: '', platform: '' },
        [field]: value
      }
    }));
  };

  const handleSyncTicketClose = () => {
    setSyncTicketModal(false);
  }

  const showPartnerLimitModal = (title, content) => {
    Modal.error({
      title,
      content: (
        <div style={{ whiteSpace: 'pre-line' }}>
          {content}
        </div>
      ),
    });
  };

  const handleTicketLimitError = (response) => {
    const limitData = response?.data || {};
    const limitType = String(limitData?.type || '').toLowerCase();
    const limitCheckFail = limitData?.limitCheckFail === true;

    if (!limitCheckFail) {
      message.error(response?.msg || 'Check partner ticket limit failed.');
      return;
    }

    if (limitType === 'expiration') {
      showPartnerLimitModal(
        'Expiration Time Reached',
        'Your partnership service has expired. Please renew your service or contact info@cyberoo.ai for assistance.'
      );
      return;
    }

    if (limitType === 'limit') {
      showPartnerLimitModal(
        'Partner Quota Limit',
        "Your partner's ticket quota has been fully used. Please upgrade your plan or contact info@cyberoo.ai for more capacity."
      );
      return;
    }

    message.error(limitData?.errorMsg || response?.msg || 'Check partner ticket limit failed.');
  };

  const handleOk = async () => {
    try {
      setConfirmLoading(true);
      const values = await form.validateFields();
      await onFinish(values);
      await fetchExamine();
    } catch (errorInfo) {
      message.error(errorInfo);
    } finally {
      setConfirmLoading(false);
    }
  };

  const handleCreateTicket = async () => {
    const partnerId = partnerInfo?.partnerId;
    const partnerName = partnerInfo?.partnerName || '';
    const companyId = userProfile?.user?.companyId;
    const companyName = userProfile?.user?.companyName || '';
    if (!partnerId) {
      message.error('Partner information is missing.');
      return;
    }

    const ticketItems = Object.values(ticketDetails);
    if (ticketItems.some(item => !item.brand)) {
      message.warning('Please select a brand for each CTA before creating tickets.');
      return;
    }

    const phones = [];
    const urls = [];
    const ticketLimitGroups = ticketItems.reduce((groups, item) => {
      const key = `${partnerId}-${item.brand}`;
      if (!groups[key]) {
        groups[key] = {
          partnerId,
          brandId: item.brand,
          count: 0,
        };
      }
      groups[key].count += 1;
      return groups;
    }, {});
    const ctaLogs = []; // 用数组收集

    setConfirmLoading(true);

    try {
      for (const group of Object.values(ticketLimitGroups)) {
        const response = await checkPartnerTicketLimit({
          partnerId: group.partnerId,
          brandId: group.brandId,
          batchSize: group.count > 1 ? group.count : 1,
        });

        if (response?.code !== 200 || response?.data?.limitCheckFail === true) {
          handleTicketLimitError(response);
          return;
        }
      }

      ticketItems.forEach((item) => {
        if (item.type === 'Phone') {
          phones.push({
            brand: item.brand || '',
            brandName: getBrandLabelByValue(item.brand),
            platform: item.platform || '',
            cta: item.cta,
            type: item.type,
            conversationId: item.conversationId,
            email: item.email,
            partnerId,
            partnerName,
            ctaId: item.ctaId,
            companyId,
            companyName
          });

          ctaLogs.push(`CTA: ${item.cta}`);
        } else if (item.type === 'URL') {
          urls.push({
            brand: item.brand || '',
            brandName: getBrandLabelByValue(item.brand),
            cta: item.cta,
            type: item.type,
            conversationId: item.conversationId,
            email: item.email,
            partnerId,
            partnerName,
            ctaId: item.ctaId,
            companyId,
            companyName
          });

          ctaLogs.push(`CTA: ${item.cta}`);
        }
      });

      const logContent = ctaLogs.join('\n');
      const userId = conversation.userId;

      const createTicketResponse = await createTicket({ phones, urls, logContent, userId, userName: userProfile?.user?.nickName || userProfile?.user?.name ||  userProfile?.user?.userName });
      if (createTicketResponse?.code === 200 && createTicketResponse?.success === true) {
        const pendingWorkOrders = {};
        Object.values(ticketDetails).forEach(item => {
          pendingWorkOrders[item.ctaId] = {
            workOrderId: '',
            brandName: getBrandLabelByValue(item.brand),
          };
        });
        setWorkOrderMap(prev => ({
          ...prev,
          ...pendingWorkOrders,
        }));
        setCtaSyncData([]);
        setBoxCount(0);
        setTicketDetails({});
        message.success('Ticket created successfully.');
      } else {
        message.error(createTicketResponse?.msg || 'Ticket creation failed.');
        return;
      }
      setSyncTicketModal(false);
    } finally {
      setConfirmLoading(false);
    }
  };

  const onChangeNewBrand = (checked) => {
    setNewBrand(checked);
  }

  const onFinish = async values => {

    let englishName;
    if (!newBrand) {
      brands.forEach(item => {
        if (item.value === values.brand) {
          englishName = item.label.split('[')[0].replace(/\s+$/, '');
        }
      })
    }

    const params = {
      ...values,
      chineseName: values.chineseName,
      englishName: englishName,
      type: values.type,
      country: values.country,
      industry: values.industry,
      brand: values.brand,
      ctaList: ctaSyncData,
      newBrand: newBrand,
      conversationId: conversation.conversationId,
      userId: userProfile?.user?.userId
    };

    const res = await addOptimusInspection(params);
    if (String(res) === '1') {
      setSyncCtaModal(false);//close model
      form.resetFields();//form clear
      setNewBrand(false);
      setCtaSyncData([]);
      setBoxCount(0);

      message.success('Operation successful');
    } else {
      message.error(String(res) === '0' ? 'Sync to Optimus failed.' : String(res || 'Sync to Optimus failed.'));
    }

  };
  const closeDrawer = () => {
    setIsLogCenterOpen(false)
  }

  return (
    <div className="p-6">
      <div className="mb-6 flex items-center">
        <Button icon={<ArrowLeftOutlined />} onClick={() => handleNavigate()} type="link">
          Back
        </Button>
      </div>

      <Card
        title={<Text strong style={{ fontSize: 16 }}>Review</Text>}
        extra={
          <Space>
            {userProfile?.user?.userStatus !== "Company User" && <Button
              onClick={() => ctaAsyncOptimus()}
              disabled={boxCount === 0}
            >
              Add to Optimus
            </Button>}
            {userProfile?.user?.userStatus !== "Company User" && <Space.Compact>
              <Button
                type="primary"
                onClick={() => handleExamineConversation(false)}
                disabled={isButtonDisabled}
                loading={loading}
              >
                Approved
              </Button>
              <Dropdown menu={menu} placement="bottomRight" disabled={isButtonDisabled}>
                <Button type="primary" icon={<MoreOutlined />} />
              </Dropdown>
            </Space.Compact>}
            {partnerInfoLoaded && userProfile?.user?.userStatus == "Company User" && partnerInfo?.partnerId != null && (
              <Button
                type="primary"
                onClick={() => ctaAsyncTicket()}
                disabled={ctaSyncData.length === 0}
              >
                Create Ticket
              </Button>
            )}
            {partnerInfoLoaded && (userProfile?.user?.userStatus == "Login User" || partnerInfo?.partnerId != null) &&
              <Button
                icon={
                  <img
                    src={logIcon}
                    alt="log"
                    style={{ width: 30, height: 30 }}
                  />
                } onClick={() => fetchLog()}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: 0,
                  border: "none",
                  background: "none",
                  boxShadow: "none",
                }}
              >

              </Button>
            }
          </Space>
        }
      >
        <Row gutter={[16, 16]} align="middle">
          <Col span={4}>
            <Text>source:</Text>
          </Col>

          <Col span={8}>
            {isCompanyUser ? (
              <Text>{source || "-"}</Text>
            ) : (
              <Input
                value={source}
                onChange={e => handleEditSource(e.target.value)}
              />
            )}
          </Col>

          <Col span={4}>
            <Text>involved organization:</Text>
          </Col>

          <Col span={8}>
            {isCompanyUser ? (
              <Text>{involvedOrganization || "-"}</Text>
            ) : (
              <Input
                value={involvedOrganization}
                onChange={e => handleEditInvolvedOrganization(e.target.value)}
              />
            )}
          </Col>
        </Row>

        <Row gutter={[16, 16]} align="middle" style={{ marginTop: 12 }}>
          <Col span={4}><Text>risk level:</Text></Col>
          <Col span={8}>
            {isCompanyUser ? (
              <Text>{riskLevel || '-'}</Text>
            ) : (
              <Select
                value={riskLevel}
                style={{ width: '100%' }}
                onChange={(value) => handleEditRiskLevel(value)}
              >
                <Option value="Minimal">Minimal</Option>
                <Option value="Low">Low</Option>
                <Option value="Moderate">Moderate</Option>
                <Option value="High">High</Option>
              </Select>
            )}
          </Col>

          <Col span={4}><Text>risk score:</Text></Col>
          <Col span={8}><Text>{riskCore || '-'}</Text></Col>
        </Row>


        {!isCompanyUser && (
          <Row gutter={[16, 16]} align="middle" style={{ marginTop: 12 }}>
            {ctas.length === 0 && (
              <Col span={24} style={{ display: 'flex', justifyContent: 'center' }}>
                <Button onClick={addCta}>Add Cta</Button>
              </Col>
            )}
          </Row>
        )}


        {ctas.map((cta) => {
          const workOrder = workOrderMap[cta.ctaId];
          const hasWorkOrder = hasTicketCreated(workOrder);
          const checkboxDisabled = hasWorkOrder || (isCompanyUser ? (cta.ctaType !== 'URL' && cta.ctaType !== 'Phone') : cta.ctaType !== 'URL');
          const ctaContent = (
          <Tooltip
            key={cta.key}
            title={hasWorkOrder ? ticketDisabledTooltip : ''}
            placement="topLeft"
            mouseEnterDelay={0.3}
            getPopupContainer={(triggerNode) => triggerNode.parentElement?.parentElement || document.body}
          >
            <div style={{ borderTop: '1px solid #f0f0f0', marginTop: 16, paddingTop: 12 }}>
            <Row gutter={[24, 16]} align="middle">
              {(userProfile?.user?.userStatus !== "Company User" || partnerInfo?.partnerId != null) && (
                <Col span={1}>
                  <Checkbox
                    disabled={checkboxDisabled}
                    checked={ctaSyncData.some(item => item.ctaId === cta.ctaId)}
                    onChange={(e) =>
                      onChangeCheckbox(cta.ctaId, cta.finalCta || cta.cta, e.target.checked, cta.ctaType)
                    }
                  />
                </Col>
              )}

              <Col span={3}>
                {hasWorkOrder && (
                  <div style={{ marginBottom: 4, display: 'flex', alignItems: 'center', gap: 8 }}>
                    <Tag color="blue">{workOrder.workOrderId}</Tag>
                    <Tag color="blue">{workOrder.brandName.length > 6 ? workOrder.brandName.slice(0, 6) + '...' : workOrder.brandName}</Tag>
                  </div>
                )}
                {cta.relatedBrands && cta.ctaType && (
                  <Tag
                    bordered={false}
                    color="processing"
                    style={{
                      whiteSpace: 'normal',
                      wordBreak: 'break-word'
                    }}
                  >
                    {cta.relatedBrands}
                  </Tag>
                )}
              </Col>

              <Col span={12}>
                <Row gutter={[16, 16]} align="middle">
                  <Col span={6}><Text>cta:</Text></Col>

                  <Col span={12}>
                    {isCompanyUser ? (
                      <CollapsibleTextBlock text={cta.cta || '-'} lines={3} />
                    ) : (
                      <Input
                        value={cta.cta}
                        onChange={e => handleEdit(cta.key, 'cta', e.target.value)}
                      />
                    )}
                  </Col>

                  <Col span={6}>
                    {!isCompanyUser && (
                      <Space size="small">
                        <Button icon={<PlusOutlined />} onClick={addCta} />

                        <Button
                          icon={
                            <img
                              src={Jump}
                              alt="icon"
                              style={{ width: 16, height: 16, verticalAlign: 'middle' }}
                            />
                          }
                          style={{ borderColor: '#1890ff', color: '#1890ff' }}
                          onClick={() => handleJumpToCTADetail(cta)}
                        />

                        <Button
                          icon={<DeleteOutlined />}
                          onClick={() => deleteCta(cta.key)}
                          danger
                        />
                      </Space>
                    )}
                    {isCompanyUser && (
                      <Space size="small">
                        <Button
                          icon={
                            <img
                              src={Jump}
                              alt="icon"
                              style={{ width: 16, height: 16, verticalAlign: 'middle' }}
                            />
                          }
                          style={{ borderColor: '#1890ff', color: '#1890ff' }}
                          onClick={() => handleJumpToCTADetail(cta)}
                        />
                      </Space>
                    )
                    }
                  </Col>
                </Row>
              </Col>

              <Col span={8}>
                <Row align="middle">
                  <Col span={8}><Text>idCta: </Text></Col>
                  <Col span={12}><Text>{cta.ctaId || '-'}</Text></Col>
                </Row>

                <Row align="middle">
                  <Col span={8}><Text>ctaType: </Text></Col>
                  <Col span={12}><Text>{cta.ctaType || '-'}</Text></Col>
                </Row>

                <Row align="middle">
                  <Col span={8}><Text>Trust List Status: </Text></Col>
                  <Col span={12}>
                    <Text>
                      {cta.isWhitelist === null
                        ? '-'
                        : cta.isWhitelist === '0'
                          ? 'Not Listed'
                          : cta.isWhitelist === '1'
                            ? 'Whitelisted'
                            : cta.isWhitelist === '2'
                              ? 'Blacklisted'
                              : '-'}
                    </Text>
                  </Col>
                </Row>

                <Row align="middle">
                  <Col span={8}><Text>finalCta: </Text></Col>
                  <Col span={12}><CollapsibleTextBlock text={cta.finalCta || '-'} lines={3} /></Col>
                </Row>

                <Row align="middle">
                  <Col span={8}><Text>isMobile: </Text></Col>
                  <Col span={12}><Text>{cta.isMobile || '-'}</Text></Col>
                </Row>
              </Col>

            </Row>
            </div>
          </Tooltip>
          );
          return ctaContent;
        })}

      </Card>
      {userProfile?.user?.userStatus !== "Company User" && (
        <Card title="AI Review" className="mb-6" loading={loading}>
          <Table
            columns={columns}
            dataSource={aiReviewData}
            pagination={false}
            loading={loading}
          />
        </Card>)
      }
      <Card title="User Information" className="mb-6" loading={loading}>
        <Descriptions
          column={5}
          contentStyle={{ minWidth: 120 }}
        >
          <Descriptions.Item label="User ID">{userInfo.name}</Descriptions.Item>
          <Descriptions.Item label="Email">{userInfo.email}</Descriptions.Item>
          <Descriptions.Item label="Registration Time">
            {moment(userInfo.createdAt).format('YYYY-MM-DD HH:mm')}
          </Descriptions.Item>
          <Descriptions.Item label="Last Login Time">
            {moment(userInfo.lastLoginTime).format('MM-DD HH:mm')}
          </Descriptions.Item>
          <Descriptions.Item label={userInfo.userStatus == 'Email User' ? 'Message Count' : 'Login Count'}>
            {userInfo.userStatus == 'Email User' ? userInfo.messageCount : userInfo.loginCount} times
          </Descriptions.Item>
        </Descriptions>
      </Card>

      <Card loading={loading} className="p-4">
        {conversation != undefined && (
          <div style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '16px', display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: '10px' }}>Conversation ID: {conversation.conversationId}</span>
            {messages.some(msg => msg.isQuestionBank) && <Tag>Question Bank</Tag>}
          </div>
        )}
        <Timeline>
          {messages.map((msg, index) => (
            <Timeline.Item key={index}>
              <div style={{ color: '#888', fontSize: '12px' }}>
                {moment(msg.time).format('YYYY-MM-DD HH:mm:ss')}
              </div>
              <div style={{ marginTop: '4px' }}>
                {msg.sender === "AI" ? (
                  <>
                    <Text style={{ display: 'block', marginBottom: '12px' }}>DeepTrace:</Text>
                    <Text
                      style={{
                        display: 'block',
                        marginBottom: '12px',
                        whiteSpace: 'pre-line',
                      }}
                    >
                      {msg.tpContent
                        ?.replace(/\|/g, '\n')
                        .replace(/#/g, ' ')
                      }
                    </Text>

                    <Text strong>{msg.sender}:</Text>
                    <br />
                    <JsonDisplay data={msg.content} />
                  </>
                ) : (
                  <>
                    <br />
                    {React.isValidElement(msg.content) ? (
                      msg.content
                    ) : msg.sender === "User" ? (
                      String(msg.content)
                        .split('\n')
                        .map(line => line.trim())
                        .filter(line => line.length > 0)
                        .map((line, idx) => (
                          <Paragraph key={idx} style={{ marginBottom: '8px' }}>
                            {renderParagraphs(line)}
                          </Paragraph>
                        ))
                    ) : (
                      <Text>{msg.content}</Text>
                    )}
                  </>
                )}
              </div>
            </Timeline.Item>
          ))}
        </Timeline>
      </Card>
      <Modal
        title="Sync to Optimus"
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={syncCtaModal}
        onOk={handleOk}
        onCancel={handleSyncCtaClose}
        confirmLoading={confirmLoading}
        width={'50%'}
      >
        <span style={{ marginRight: 8 }}>Add a new brand:</span>
        <Checkbox checked={newBrand} onChange={(e) => onChangeNewBrand(e.target.checked)}></Checkbox>

        <Form
          form={form}
          name="basic"
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 18 }}
          autoComplete="off"
        >
          <br />

          {newBrand ? (
            <>
              <Form.Item
                label="Chinese Name:"
                name="chineseName"
                rules={[{ required: newBrand, message: 'Please input chineseName!' }]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Customer Type:"
                name="customerType"
                rules={[{ required: newBrand, message: 'Please input customerType!' }]}>
                <Radio.Group>
                  <Radio value="POTENTIAL"> Former Client </Radio>
                  <Radio value="NON-CLIENT"> Non-Client </Radio>
                </Radio.Group>
              </Form.Item>

              <Form.Item
                label="Country/Region:"
                name="country"
                rules={[{ required: newBrand, message: 'Please input type!' }]}
              >
                <Select
                  allowClear
                  options={countryCode}
                ></Select>
              </Form.Item>

              <Form.Item
                label="Industry:"
                name="industry"
                rules={[{ required: newBrand, message: 'Please input type!' }]}
              >
                <Select
                  allowClear
                  options={industry}

                ></Select>
              </Form.Item>
            </>
          ) : (
            <Space.Compact style={{ width: '100%' }}>
              <Form.Item
                label="Client/Brand:"
                name="brand"
                rules={[{ required: !newBrand, message: 'Please input Client/Brand!' }]}
                noStyle
              >
                <Select
                  placeholder="Please select a brand"
                  allowClear
                  options={brands}
                  style={{ flex: 1 }}
                  showSearch
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                  }
                />
              </Form.Item>
              <Button icon={<UndoOutlined />} onClick={() => getOptimusBrands(true)} />

            </Space.Compact>
          )
          }
        </Form>
      </Modal>
      <Drawer
        placement="right"
        width={"80%"}
        onClose={closeDrawer}
        open={isLogCenterOpen}
      >
        {isCompanyUser &&
          <Table
            rowKey="operId"
            columns={logTicketColumns}
            dataSource={examineLogList}
            loading={loading}
            scroll={{ x: "max-content" }}
            pagination={false}
          />
        }
        {!isCompanyUser &&
          <Table
            rowKey="conversationId"
            columns={logColumns}
            dataSource={examineLogList}
            loading={loading}
            scroll={{ x: "max-content" }}
            pagination={false}
          />
        }
      </Drawer>


      <Modal
        title="Create Ticket"
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={syncTicketModal}
        onOk={handleCreateTicket}
        onCancel={handleSyncTicketClose}
        confirmLoading={confirmLoading}
        width={'50%'}
      >

        {/* CtaBrandRow */}
        {brandRows.map((item, index) => (
          <React.Fragment key={`brand-${index}`}>
            <CtaBrandRow
              key={index}
              cta={item.cta}
              brands={partnerBrandOptions}
              brandValue={ticketDetails[item.ctaId]?.brand}
              onBrandChange={(value) => handleTicketChange(item.ctaId, 'brand', value)}
            />
            {index < brandRows.length - 1 && <Divider />}
          </React.Fragment>
        ))}
        {brandRows.length > 0 && ctaInfoSections.length > 0 && <Divider />}

        {/* CtaInfoSection */}
        {ctaInfoSections.map((item, index) => (
          <React.Fragment key={`info-${index}`}>
            <CtaInfoSection
              cta={item.cta}
              brands={partnerBrandOptions}
              brandValue={ticketDetails[item.ctaId]?.brand}
              platforms={platformOptions}
              platformValue={ticketDetails[item.ctaId]?.platform}
              onPlatformChange={(value) => handleTicketChange(item.ctaId, 'platform', value)}
              onBrandChange={(value) => handleTicketChange(item.ctaId, 'brand', value)}
            />

            {index < ctaInfoSections.length - 1 && <Divider />}
          </React.Fragment>
        ))}

      </Modal>
    </div>
  );
};

export default ConversationDetail;
